import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Practice from './pages/Practice';
import AccentTest from './pages/AccentTest';
import Results from './pages/Results';
import Dashboard from './pages/Dashboard';
import Navbar from './components/Navbar';
import { Toaster } from './components/ui/toaster';
import { PageMeta } from './lib/pageMeta';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App cz-backdrop">
      <BrowserRouter>
        <ScrollToTop />
        <PageMeta />
        <Navbar />
        {/* bottom padding clears the mobile tab bar */}
        <main className="pb-28 md:pb-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/practice" element={<Practice />} />
            <Route path="/accent-test" element={<AccentTest />} />
            <Route path="/results" element={<Results />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </main>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
